<template>
    <div>
        <div class="bg-back">
            <div class=" pt-7 pl-5" @click="clickBack()">
                <img class=" w-5" src="../../assets/icon/pwp-ic-back-new.svg"/>
            </div>
        </div>
        <div class="container mx-auto">
            <div class=" flex justify-center">
                <div class="ic-app">
                    <img :src="getAppImage()"/>
                    <!-- <img src="../../assets/icon/ic-pwp-app.png"/> -->
                </div>
                <div class="ic-tranfer my-auto mx-4">
                    <img src="../../assets/icon/ic-pwp-app-change.svg"/>
                </div>
                <div class="ic-mepoints">
                    <img src="../../assets/icon/ic-pwp-mepoint.png"/>
                </div>
            </div>
            <div class=" text-center pt-5 text-16">
                <div class=" font-semiBold text-a-black-080909">{{lbl.paywithpoint.avaliable_points}}</div>
                <div class=" font-Medium pt-1.5 text-26" :style="textStyle">{{getPoint()}}</div>
                <div class=" font-text text-a-gray-666666 ">{{lbl.paywithpoint.can_redeem}} <a :style="textStyle">{{FilterNumberFormat(pointUser)}} {{lbl.paywithpoint.baht}}</a></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PWPHeader',
    props: {
        lbl: Object,
        blobConfig: { type: Object },
        rate: { type: Object },
    },
    data: function() {
        return {
            textStyle: {
                color : '',
            },
            pointUser: 0,
        }
    },
    created: function() {
        this.setupTheme();
        this.convertUserPoint();
    },
    methods: {
        setupTheme: function() {
            this.textStyle.color = this.blobConfig.appConfig.blobConfig.text_color
        },
        getAppImage: function() {
            return `${this.blobConfig.blobUrl}/image/${this.blobConfig.appConfig.blobConfig.file_name}`;
        },
        getPoint: function() {
            if (this.blobConfig.query.appName == "lineCiti") {
                return this.FilterNumberFormat(this.blobConfig.citiPoint.balance)
            } else {
                return this.FilterNumberFormat(this.rate.CurrentPoints)
            }
        },
        convertUserPoint: function() {
            if (this.blobConfig.query.appName == "lineCiti") {
                return this.pointUser = Math.floor(this.blobConfig.citiPoint.balance * this.rate.ConvertRate)
            } else {
                return this.pointUser = Math.floor(this.rate.CurrentPoints * this.rate.ConvertRate)
            }
        },
        clickBack: function() {
            this.$emit('clickBack');
            // window.location.replace(this.blobConfig.query.returnUrl)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
.font-text {
    font-family: $ff-text;
}
.font-Medium {
    font-family: $ff-Medium;
}
.font-semiBold {
    font-family: $ff-semi;
}

.bg-back {
    width: 80px;
    height: 72px;
    background-color: #080909;
    border-bottom-right-radius: 40px;
}
.ic-app {
    width: 75px;
}
.ic-tranfer{
    width: 19px;
}
.ic-mepoints {
    width: 75px;
}

.container {
    max-width: $max-width-l-mobile;
}
</style>
